import { Component, Input, OnInit } from "@angular/core";
import { User } from "../../../../../shared/models/user";
import { Tournament } from "../../../../../shared/models/tournament";

@Component({
  selector: "app-view-tournament-mobile-players",
  templateUrl: "./view-tournament-mobile-players.component.html",
  styleUrls: ["./view-tournament-mobile-players.component.scss"],
})
export class ViewTournamentMobilePlayersComponent implements OnInit {
  @Input() tournament: Tournament;
  @Input() user: User;
  constructor() {}

  ngOnInit(): void {}
}
